
(function(){
  function initQuickAdd() {
    var btns = document.querySelectorAll('.quick-add-btn:not([data-quick-init])');
    btns.forEach(function(btn) {
      btn.setAttribute('data-quick-init', 'true');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId || this.disabled) return;
        this.disabled = true;
        var origText = this.textContent;
        this.textContent = 'Hozzáadva ✓';
        var self = this;
        // FIX 2026-05-23 — r.ok check. A korábbi kód `.then(r=>r.json())`-rel
        // a 4xx/5xx választ is sikerként kezelte: a 422 ("Már nem kapható …")
        // után „Hozzáadva ✓"-t írt, dispatchelte az ajaxProduct:added-et
        // (drawer megnyitva a meglévő kosárral), miközben a termék NEM került
        // be — a vevő azt hitte, hogy be van rakva.
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: parseInt(variantId), quantity: 1}]})
        })
        .then(function(r) {
          return r.json().then(function(json) {
            if (!r.ok) {
              var msg = (json && (json.description || json.message)) || ('HTTP ' + r.status);
              var err = new Error(msg);
              err.shopify = json;
              err.status = r.status;
              throw err;
            }
            return json;
          });
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          var bubble = document.querySelector('.cart-link__bubble');
          if (bubble) bubble.classList.add('cart-link__bubble--visible');
          setTimeout(function() { self.disabled = false; self.textContent = origText; }, 2000);
        })
        .catch(function(err) {
          self.disabled = false;
          try { if (window.console && console.warn) console.warn('quick-add failed:', err); } catch(_) {}
          var msg = (err && err.message) ? String(err.message) : 'Hiba';
          self.textContent = msg.length > 24 ? 'Nem elérhető' : msg;
          setTimeout(function() { self.textContent = origText; }, 3500);
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAdd);
  } else {
    initQuickAdd();
  }
  // Re-init on AJAX pagination
document.addEventListener('DOMContentLoaded', function() {
  var observer = new MutationObserver(function() { initQuickAdd(); });
  observer.observe(document.body, {childList: true, subtree: true});
});
})();
